import { attr, fk } from 'redux-orm';
import Model from '../base-model';
import { chatActions } from './chat.action';
import chatReducers from './chat.reducer';


/**
 * Chat
 * @typedef {Object} Chat
 * @property {string} id
 * @property {string} chatType
 * @property {Date} created
 * @property {string} lastMessage
 * @property {number} unseenMessages
 * @property {ForumUser} receiver
 */

export class Chat extends Model {

    static reducer(action, Self, session) {
       switch (action.type) {
           case chatActions.create:
               chatReducers.create(session, action.chat);
               break;
           case chatActions.addMessage:
               chatReducers.addMessage(session, action.message, action.chatId);
               break;
           default:
               return undefined;
       }
    }

    toString() {
        return `Chat: ${this.chatType}`
    }
}

Chat.modelName = 'Chat';

Chat.fields = {
    id: attr(),
    chatType: attr(),
    created: attr(),
    unseenMessages: attr(),
    lastMessage: fk('ChatMessage'),
    receiver: fk('ForumUser'),
}


/**
 * ChatMessage
 * @typedef {Object} ChatMessage
 * @property {string} id
 * @property {string} text
 * @property {Date} created
 * @property {boolean} is_seen
 * @property {string} chat 
 * @property {ForumUser} sender
 */

export class ChatMessage extends Model {
    toString() {
        return `Chat: ${this.chat}`
    }
}
ChatMessage.modelName = 'ChatMessage';

ChatMessage.fields = {
    id: attr(),
    text: attr(),
    file: attr(),
    is_seen: attr(),
    created: attr(),
    chat: fk('Chat', 'messages'),
    sender: fk('ForumUser', 'message'),
}
